<script setup lang="ts">
import IconButton from '~/components/IconButton.vue';
import CreateProfileModal from "~/features/profiles/CreateProfileModal.vue";
import { useProfileStore } from "~/store/profiles";
import { generateEntityId } from '~/common/types/helpers';
import type { Org, Profile } from "~/common/types/types";
const store = useProfileStore();
const isModalOpen = ref(false);

const props = defineProps({
  org: {
    type: Object as PropType<Org>,
    required: true,
  },
});

const profile = ref();
const buildDefaultProfile = (): Profile => ({
  _id: generateEntityId(),
  orgId: props.org._id,
  name: "",
  description: "",
  email: "",
  programming_languages: [],
  communication_languages: [],
  phone: "",
  created: new Date(),
  socials: []
});
function startNew() {
  profile.value = buildDefaultProfile();
  isModalOpen.value = true;
}

</script>

<template>
    <span><IconButton @click="startNew" 
        type="add"
        size="sm"
        color="primary"
        square
        variant="link"
        title="Create New"></IconButton>
        <CreateProfileModal
            v-if="isModalOpen"
            v-model="profile"
            @close="isModalOpen = false"
            @submitted="(profile: Profile) => store.addProfile(profile)"
        />
    </span>
</template>